import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import { SCUIContent } from '../../atomic/organisms';
import { SCUITabs } from '../../atomic/atoms';
import { RetroBoard } from '../RetroBoard';
import { WeeklyWorkLogPanel } from './components/WeeklyWorkLogPanel';
import './JiraTracker.scss';

const TAB_PLANNER = 0;
const TAB_RETRO = 1;

function readTabFromQuery(search: string): number {
    const params = new URLSearchParams(search);
    const tab = (params.get('tab') || '').trim().toLowerCase();
    if (tab === 'retro') return TAB_RETRO;
    if (params.get('room')) return TAB_RETRO;
    return TAB_PLANNER;
}

export const DailyPlanner: FC = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(() => readTabFromQuery(location.search));

    const tabList = useMemo(
        () => [
            { id: TAB_PLANNER, name: t('dailyPlanner.tabs.planner') },
            { id: TAB_RETRO, name: t('dailyPlanner.tabs.retro') },
        ],
        [t]
    );

    const handleTabChange = (_event: unknown, nextTab: number) => {
        setActiveTab(nextTab);
        const params = new URLSearchParams(location.search);
        if (nextTab === TAB_RETRO) {
            params.set('tab', 'retro');
        } else {
            params.delete('tab');
            params.delete('room');
        }
        const search = params.toString();
        history.replace({ pathname: location.pathname, search: search ? `?${search}` : '' });
    };

    return (
        <SCUIContent headerName={t('dailyPlanner.title')}>
            <Box className="daily-planner-page">
                <SCUITabs
                    tabList={tabList}
                    activeTabIndex={activeTab}
                    onChange={handleTabChange}
                    iconShow={false}
                />

                {activeTab === TAB_PLANNER && <WeeklyWorkLogPanel />}
                {activeTab === TAB_RETRO && <RetroBoard embedded />}
            </Box>
        </SCUIContent>
    );
};

export default DailyPlanner;
